import {fetch} from "utils/dataAccess";

/**
 * The five catalogue KPI counters of a retailer, each with its variation against a past
 * window. Reads the daily snapshot server-side, so it is cheap enough to call on every
 * period change.
 *
 * @param retailerId {string} bare uuid, without the /retailers/ prefix
 * @param period {string} week | month | quarter | year
 */
export default function catalogSummary(retailerId, period) {
    return fetch(`/retailers/${retailerId}/catalog-summary?period=${period}`)
        .then((response) => response.json());
}
